import React from 'react';
import styled from 'styled-components';


const FooterWrapper = styled.footer`
min-height: 100px;
width: 100vw;
padding: 4rem 12vw;
background-color: #262020;
color: #F9F7F4;
font-size: 1.6rem;

@media (max-width: 1080px) {
        padding: 2rem 8vw;
    }
;

@media (max-width: 750px) {
        min-height: 130px;
        padding: 2rem;
        padding-left: 12vw;
    }
`;

const FooterContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .copyrights {
        flex-basis: 40%;
    }
    a {
        color: #F9F7F4;
        text-decoration: none;
    }

    @media (max-width: 1400px) {
      
    }

    @media (max-width: 1080px) {
       
    }
    @media (max-width: 750px) {
        flex-direction: column-reverse;
        height: 100%;
        a {
            margin-bottom: 0.4rem;
        }
        .copyrights  {
            margin-top: 2.6rem;
        }
    }
`;

const Footer = (props) => {
    const date = new Date();
    const todayYear = date.getFullYear();
    return (
        <FooterWrapper>
            <FooterContent>
            <div className="copyrights">&#169; {todayYear} Oprawa Muzyczna Wesel </div>
            <a href="tel:+48111-111-111">Tel: +48 111-111-111</a>
            <div>Email: <span>mariusz@topevent.pl</span> </div> 
                
            </FooterContent>
            
        </FooterWrapper>
    )
};

export default Footer